import {AuthoringQuestionSetModelV1} from 'resources/GeneratedModels/AuthoringQuestionSet/AuthoringQuestionSetModel.v1';
import {questionSetExtensions} from './questionSet.extensions';
import {authoringQuestionSetExtensions} from './authoringQuestionSet.extensions';
import {authoringQuestionSetModelValidators} from 'resources/validators/AuthoringQuestionSetModel.validators';

AuthoringQuestionSetModelV1.extend(questionSetExtensions, authoringQuestionSetExtensions);
AuthoringQuestionSetModelV1.addValidators(authoringQuestionSetModelValidators);

export {AuthoringQuestionSetModelV1};
